module.exports = __webpack_public_path__ + "img/logo.3ada6314.png";